export const PROVIDER_PROFILE_REQUEST = 'PROVIDER_PROFILE_REQUEST'
export const PROVIDER_PROFILE_INFO_SUCCESS = 'PROVIDER_PROFILE_INFO_SUCCESS'
export const PROVIDER_PROFILE_KYB_SUCCESS = 'PROVIDER_PROFILE_KYB_SUCCESS'
export const PROVIDER_PROFILE_FAILURE = 'PROVIDER_PROFILE_FAILURE'

